import moment from 'moment';
import {
  TableFilters,
  TableFilterSelect,
  InputContainer,
  DatePicker,
  BelongsToFilterSelects,
} from '../../design-system';
import { containerTypes, gateInStatusOptions, INPUT_ERRORS } from '../../const';
import { extendContainerValidator } from '../../utils';
import { i18n } from '../../i18n';

interface Props {
  containerNumber?: string;
  containerType?: any;
  clientName?: any;
  createdAt?: any;
  startDate?: any;
  endDate?: any;
  completedAt?: any;
  licensePlateNumber?: string;
  transport?: any;
  status?: any;
  handleSort: (column: string, isSet: boolean) => void;
  setStates: any;
}

export const Filters: React.FC<Props> = ({
  containerNumber = '',
  containerType,
  startDate,
  endDate,
  status,
  handleSort,
  setStates,
}: Props) => {
  return (
    <TableFilters>
      <BelongsToFilterSelects
        handleChange={(obj) => {
          setStates('force', obj);
        }}
      />
      <InputContainer
        label={i18n.t('label.containerNumber')}
        data-size={'medium'}
        defaultValue={containerNumber}
        onChange={(e) => {
          const value = e.target.value.toUpperCase();
          setStates('containerNumber', value);
        }}
        helperText={
          containerNumber.length !== 0 && containerNumber.length < 3
            ? INPUT_ERRORS.NOT_VALID.CONTAINER_NUMBER_MIN
            : !extendContainerValidator(containerNumber)
            ? INPUT_ERRORS.NOT_VALID.CONTAINER_NUMBER_SHORT
            : ''
        }
        alwaysShowHelperText
      />
      <TableFilterSelect
        label={i18n.t('label.containerType')}
        options={containerTypes}
        value={containerType}
        onChange={(e) => setStates('force', { containerType: e.target.value })}
      />
      <TableFilterSelect
        label={i18n.t('label.status')}
        options={gateInStatusOptions}
        value={status}
        onChange={(e) => {
          const otherData: any = {};
          if (e.target.value !== 'COMPLETED') otherData.completedAt = null;
          if (e.target.value === 'COMPLETED') {
            handleSort('completedAt', true);
          } else handleSort('createdAt', true);

          setStates('force', {
            status: e.target.value,
            startDate: null,
            endDate: null,
            ...otherData,
          });
        }}
      />
      {status !== 'All' &&
        [status].map(() => (
          <DatePicker
            key={Math.random()}
            label={i18n.t('label.from')}
            data-size={'medium'}
            defaultValue={startDate}
            onChange={(e) => setStates('force', { startDate: e })}
            maxDate={
              status === 'COMPLETED'
                ? endDate
                  ? moment(endDate)
                  : moment()
                : endDate
                ? moment(endDate)
                : null
            }
          />
        ))}
      {status !== 'All' &&
        [status].map(() => (
          <DatePicker
            key={Math.random()}
            label={i18n.t('label.to')}
            data-size={'medium'}
            defaultValue={endDate}
            onChange={(e) => setStates('force', { endDate: e })}
            minDate={startDate ? moment(startDate) : null}
            maxDate={status === 'COMPLETED' ? moment() : null}
          />
        ))}
    </TableFilters>
  );
};
